import { DATA_REDUX_STATE_KEY, dataCreators } from "../../actions/dataAction";
import { cmsTncController } from "../../apiService/apiController/cmsTncService";
import { ModelCMSTnc } from "../../models/ModelCMSTnc";
import { storeDispatch, storeGetState } from "../../stores";
import { ENUM } from "../constants/enum";
import { getUserAuthRedux } from "../functions/auth";
import { getCountryForSearch, handleSortParams, handleTrimParams } from "../functions/data";
import { isValidResponse } from "../functions/validation";

export const getCMSTncList = async (params = {}) => {
  const userAuth = getUserAuthRedux();
  let currentParams = storeGetState().dataRedux.cmsTncParams;
  let newParams = handleTrimParams({
    ...currentParams,
    ...params,
    app: ENUM.CMS_TYPE.TRUE_BLUE,
    // CR: Builder app lao
    available_country: getCountryForSearch(userAuth.countries).type,
    // available_country: userAuth.addressType,
  });
  if (!newParams.sort) {
    newParams.sort = 'id desc';
  }
  // else {
  //   newParams = handleSortParams(currentParams, newParams);
  // }
  const cmsTncService = cmsTncController();
  const res = await cmsTncService.searchTermsCondition(newParams);
  if (isValidResponse(res)) {
    const dataList = res.data.map(e => new ModelCMSTnc(e));
    newParams.activePage = newParams.page;
    newParams.totalData = res.total_items;
    console.log('dataList', res.data, dataList, newParams);
    storeDispatch(dataCreators.setDataRedux(DATA_REDUX_STATE_KEY.CMS_TNC_LIST, dataList));
    storeDispatch(dataCreators.setDataRedux(DATA_REDUX_STATE_KEY.CMS_TNC_PARAMS, newParams));
    return dataList;
  }
}